














import { Component, Vue } from "vue-property-decorator";
import {
  Product,
  ProductDetail,
  SectionViewedEvent,
} from "@authentic-labs/vue-component-library";
import axios from "axios";
import amplitude from "amplitude-js";
import {
  PRODUCT_DETAIL_VIEWED_EVENT,
  PRODUCT_SECTION_VIEWED_EVENT,
} from "@/utils/constants";
import { Circle2 } from "vue-loading-spinner";

@Component({
  components: {
    ProductDetail,
    Circle2,
  },
})
export default class Products extends Vue {
  get productId() {
    return this.$route.params.productId;
  }

  private product?: Product;
  private loading = true;
  private startTime: Date = new Date();
  private pageVisibility = document.visibilityState;

  async created() {
    const url =
      process.env.VUE_APP_API_URL +
      "/companies/" +
      this.$route.params.companyId +
      "/products/" +
      this.productId;
    const { data: product } = await axios.get(url);
    this.product = new Product(product);
    this.loading = false;
  }

  mounted() {
    this.startTime = new Date();
    //window.addEventListener("onbeforeunload", this.beforeUnloadListener);
    window.addEventListener("pagehide", this.beforeUnloadListener);
    document.addEventListener("visibilitychange", () => {
      //fires when user switches tabs, apps, goes to homescreen, etc.
      if (document.visibilityState == "hidden") {
        this.beforeUnloadListener();
      }
    });
  }

  beforeDestroy() {
    //window.removeEventListener("onbeforeunload", this.beforeUnloadListener);
    window.removeEventListener("pagehide", this.beforeUnloadListener);
    document.removeEventListener("visibilitychange", this.beforeUnloadListener);
  }

  private sectionViewed(eventArgs: SectionViewedEvent) {
    amplitude.getInstance().logEvent(PRODUCT_SECTION_VIEWED_EVENT, {
      section: eventArgs.sectionId,
      /* eslint-disable @typescript-eslint/camelcase */
      section_title: eventArgs.sectionName,
      duration: eventArgs.duration,
      product: this.product,
    });
  }

  private beforeUnloadListener() {
    if (!this.product) {
      throw new Error("Product is not set");
    }
    amplitude.getInstance().logEvent(PRODUCT_DETAIL_VIEWED_EVENT, {
      duration: new Date().getTime() - this.startTime.getTime(),
      product: this.product,
      productId: this.product.productId,
    });
  }
}
